import { server } from '../constants';
import { httpClient } from '../utils/HttpClient';
/**
 * user data
 * Create: 26/03/2021
 */

/**
 * updateUser(), update hri-personal-data to user data
 * Method: POST
 * @returns
 */
export function updateUser() {
  return httpClient
    .post(`${server.USER_URL}/updateUser`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * userProfile(), get user profile and user permission
 * Method: GET
 * @returns
 */
export function userProfile() {
  return httpClient
    .get(`${server.USER_URL}/userProfile`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * mockGetList() get email of all user in the system (Adapt api searching Name or Email)
 * Version: Mock
 * @returns
 */
export function mockSearchEmails(email = '') {
  return httpClient
    .get(`${server.USER_URL}/searchName`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}
